module.exports = __webpack_public_path__ + "img/img12.9c0f92bf.jpg";